import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom"
import { useNavigate, useParams } from "react-router-dom";
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';

import ReactLoading from "react-loading";

const LihatBuktiPembayaran = (props) => {
    let navigate = useNavigate();

    const [image, setImage] = useState([]);
    const [idLowonganPeserta, setLowonganPeserta] = useState();
    const [statusPembayaran, setStatusPembayaran] = useState();
    const [logoMitra, setLogoMitra] = useState();
    const [namaLowongan, setNamaLowongan] = useState();
    const [namaMitra, setNamaMitra] = useState();
    const [nominalUnik, setNominalUnik] = useState();
    const [spinner, setSpinner] = useState(false); 
    const { id } = useParams();

    const getBuktiPembayaran = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/lowonganpeserta-aktif/${id}`);
        if (response.data==='') {setSpinner(false)};
        const data = await response.data;
        console.log(data)
        setImage(data.image);
        setLowonganPeserta(data.idLowonganPeserta);
        setStatusPembayaran(data.statusPembayaran);
        setLogoMitra(data.lowongan.mitra.image);
        setNamaLowongan(data.lowongan.proposal.namaPosisi);
        setNamaMitra(data.lowongan.mitra.namaBrand);
        if (data.lowongan.proposal.nominal===null) {
            setNominalUnik(null)
        } else {
            setNominalUnik(data.lowongan.proposal.nominal+data.kodeUnik)
        }
        setSpinner(false);
    };

    useEffect(() => {
        getBuktiPembayaran();
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
        )
    }

    return (
        <div>
        <Center py={6} mb={5}>
        <VStack align='stretch' fontFamily={'Inter'}
        marginRight={'50px'}>
            <Box
                // m='10px'
                w='4xl'
                h="100%"
                // border='1px'
                borderColor='gray.200'
                justifyContent='left'
                // bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                {idLowonganPeserta===null ? (
                    <div>
                    <Text
                    pt={5}
                    pb={5}
                    color={'gray.900'}
                    fontWeight={500}
                    fontSize={'2xl'}>
                    Anda belum aktif pada lowongan berbayar manapun.
                    </Text>
                    <Button 
                    onClick={() => navigate(`/peserta/kegiatanku/statuspendaftaran/${id}`)}
                    fontSize='md' colorScheme='purple' variant='solid'>
                    Lihat Status Pendaftaran
                    </Button>
                    </div>              
                ) : (
                <Box>
                <VStack 
                spacing={'50px'}
                align='stretch'
                >   
                    <Text
                        pt={5}
                        color={'gray.900'}
                        fontWeight={600}
                        fontSize={'2xl'}>
                        Bukti Pembayaran
                    </Text>
                    <HStack>
                    <Box>
                        <img style={{width: '70px', height: '70px', objectFit: 'cover'}} src={logoMitra}/>
                    </Box>
                    <Box pl={5}>
                        <Text
                            color={'gray.700'}
                            fontWeight={600}
                            fontSize={'2xl'}>
                            {namaLowongan}
                        </Text>
                        <Text
                            pt={2}
                            color={'gray.700'}
                            fontWeight={500}
                            fontSize={'xl'}>
                            {namaMitra}
                        </Text>
                    </Box>
                    <Box style={{marginRight: '0', marginLeft: 'auto'}}>
                        <p>Pembayaran:</p>
                        <p><b>Rp{nominalUnik},-</b></p>
                    </Box>
                    </HStack>
                    {nominalUnik===null ? 
                    <Text
                        color={'gray.900'}
                        fontWeight={500}
                        fontSize={'xl'}>
                        Lowongan ini tidak berbayar
                    </Text> : null
                    }
                    <Box>
                    {image===null ? (
                        null
                    ) : (
                        <img style={{width: 'auto', height: '130%', marginBottom: '10px'}} className="preview" src={image} alt="" />
                    )}
                    </Box>
                </VStack>
                <Center pt={6}>
                    <Link to={`/peserta/kegiatanku/buktipembayaran/edit/${id}`}>
                        {image===null ? (
                            <Button isDisabled={nominalUnik===null} p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                Upload Bukti Pembayaran
                            </Button>
                        ) : (
                        statusPembayaran==="Lunas" ? (
                            <Button disabled={true} p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                Pembayaran Anda Sudah Lunas
                            </Button>
                        ) : (
                            <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                Edit Bukti Pembayaran
                            </Button>
                        ))}
                    </Link>
                </Center>
                </Box>
                )}
            </Box>
        </VStack>
        </Center>
        </div>
      );
  }

export default LihatBuktiPembayaran;